const useFormUtils = () => {
  const getFormErrorMessage = (
    errors: Record<string, { message?: string }> | undefined,
    name: string
  ) => {
    return errors && errors[name] && errors[name].message ? (
      <small className="p-error">{errors[name].message}</small>
    ) : null;
  };

  return {
    getFormErrorMessage,
  };
};

export default useFormUtils;
